// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"101":"da4283e9","130":"6603371f","483":"b6135da2","785":"8eabfeaf","998":"3d79c280"}[chunkId] + ".chunk.css";
};